export var name = 'view';
